/**
 * Which trade rows wear the green snipe-protection shield.
 *
 * A fill of an Ordinals Wallet bid settles only with our co-signature on the
 * escrow's 2-of-2 leaf, so nobody can front-run or snipe it: it is protected
 * by construction and shows the shield exactly like a protected listing
 * purchase. Rows reach the UI in a few shapes (flat feed rows, activity rows
 * with an `escrow` object, collection rows already normalised), so these read
 * all of them. Another venue's bid fill is an offer too, but not ours to vouch for.
 */
const OW_MARKETPLACE = 1

/** A trade that settled through an Ordinals Wallet bid. */
export function isOwOfferFill(row: any): boolean {
	if (!row) return false
	const source = String(row.escrow?.purchase_source ?? row.purchase_source ?? '')
	if (source.startsWith('offer')) return true
	if (row.via_bid === true) return true
	const marketplace = Number(row.marketplace ?? row.escrow?.marketplace ?? row.sale?.marketplace)
	return row.trade_type === 'offer' && marketplace === OW_MARKETPLACE
}

/** A trade nobody could have sniped: protected listing purchase, private relay, or one of our bid fills. */
export function isSnipeProtectedTrade(row: any): boolean {
	if (!row) return false
	return (
		row.protected === true ||
		row.escrow?.protected === true ||
		row.escrow?.private_relay === true ||
		row.escrow?.purchase_source === 'secure_v2' ||
		isOwOfferFill(row)
	)
}
